import React, { useRef, useState, useEffect } from "react";
import right from "../../assets/svg/right.svg";
import left from "../../assets/svg/left.svg";
import gatein from "../../assets/svg/gatein.svg";
import gateout from "../../assets/svg/gateout.svg";
import dockin from "../../assets/svg/dockin.svg";
import dockout from "../../assets/svg/dockout.svg";
import queue from "../../assets/svg/queue.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import downArrow from "../../assets/svg/arrow-down.svg";
import mawalog from "../../assets/svg/mawaloglogo.svg";


import time from "../../assets/svg/time.svg";
import { DList } from "../../Constent/Constent";
import { BarChart, Cell, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LabelList } from "recharts";
import { getAvailableDocksApi, getCountApi, getLiveMonitorApi, getLocationFreeDocksApi, getTimingListApi, locationBasedDockOutDockInApi } from "./dashboard-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

const data = [
  { name: "Chennai", dockIn: 120, dockOut: 100, value: 187 },
  { name: "Pune", dockIn: 80, dockOut: 60, value: 175 },
  { name: "Mumbai", dockIn: 100, dockOut: 80, value: 137 },
  { name: "Delhi", dockIn: 30, dockOut: 20, value: 116 },
  { name: "Bengaluru", dockIn: 150, dockOut: 120, value: 104 },
  { name: "Kolkata", dockIn: 90, dockOut: 70 },
  { name: "Assam", dockIn: 130, dockOut: 100 },
];
const filteredData = data.filter((item) => item.value !== undefined);

const Custom2Tooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    console.log(payload);
    return (
      <div
        style={{
          background: "hsla(0, 0.00%, 14.50%, 0.94)",
          border: "1px solid #ccc",
          color: "white",
          padding: 5,
          fontSize: 12,
          boxShadow: "0px 2px 6px hsla(0, 1.20%, 32.90%, 0.81)",
        }}>
        <div>{`${payload[0]?.payload?.location} : ${payload[0].value}`}</div>
      </div>
    );
  }
  return null;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
          // background: "transparent",
          boxShadow: "none",
          borderRadius: "5px",
          fontSize: "14px",
        }}>
        <p>{label}</p>
        <p>
          <span style={{ color: "#f66" }}>●</span> Dock in : {payload[0].value}
        </p>
        <p>
          <span style={{ color: "#fbb" }}>●</span> Dock out : {payload[1].value}
        </p>
      </div>
    );
  }
  return null;
};

const Default = () => {
  const scrollRef = useRef(null);
  const handleScroll = (dir) => {
    const scrollAmount = 200;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  /*  const details = Array(3).fill({
        vehicleNumber: "TN 08 AV 5645",
        time: "01:45 PM",
        dockno: "L2",
        Timer: "00:38:12",
      }); */
 
  const [availableDockList, setAvailableDockList] = useState([]);
  const [dockCount, setDockCount] = useState();
  const [liveMonitorList, setLiveMonitorList] = useState([]);
  const [timingList, setTimingList] = useState([]);
  const [locationBasedInAndOut, setLocationBasedInAndOut] = useState([]);
  const [freeDocks, setFreeDocks] = useState();
  const [locationDIDOCount, setLocationDIDOCount] = useState(null);

   const percentage = 43;
  const totalSegments = 30;
  const activeSegments = Math.round(((freeDocks?.dock_percentage??0) / 100) * totalSegments);

  const segments = Array.from({ length: totalSegments }, (_, i) => {
    const rotation = (i / totalSegments) * 180 - 90;
    const isActive = i < activeSegments;

    return <rect key={i} x="-2" y="-90" width="4" height="20" fill={isActive ? "#eb4d4b" : "#eee"} transform={`rotate(${rotation})`} rx="2" />;
  });
  
  const [selected, setSelected] = useState(null); // no default selection
  const pickerRef = useRef();

  const handleClick = () => {
    pickerRef.current.show();
  };

  const handleChange = (year, month) => {
    setSelected({ year, month });
    console.log(`${String(month).padStart(2, "0")}${year}`);
  };

  const pickerLang = {
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  };

  const CircleLabel = ({ x, y, width, value, height, index }) => {
    const radius = 14;
    const padding = 10;
    const textX = x + padding;
    const textY = y + height / 2 + 1;
    const cx = x + width - radius - 4; // padding from right
    const cy = y + height / 2;
    const city = freeDocks?.docks[index].location;


    

    return (
      <g>
        <foreignObject x={textX} y={textY - 20} width={width - 40} height={42}>
          <div fill="#172B4D" dominantBaseline="middle" style={{ width: `${width - 40}px`, height: "36px", display: "flex", alignItems: "center", fontSize: "14px", fontFamily: "Epilogue", fontWeight: "400", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {city}
          </div>
        </foreignObject>
        <circle cx={cx} cy={cy} r={radius} fill="#fff" />
        <text x={cx} y={cy} textAnchor="middle" fontFamily="Epilogue" dominantBaseline="central" fill="#D35258" fontSize="13" fontWeight="600">
          {value}
        </text>
      </g>
    );
  };
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const alertDatePicTotalBookingRef = useRef(null);           
useEffect(() => {
    if(selectedMonth!=null){
locationBasedDockOutDockIn();
    }    
  }, [selectedMonth]);

   useEffect(() => {
               // Attach event listener to the document
               document.addEventListener("mousedown", handleCloseDatePicker);
               return () => {
                 // Clean up event listener on unmount
                 document.removeEventListener("mousedown", handleCloseDatePicker);
               };
             }, []);

             const handleCloseDatePicker = (event) => {               
               if (alertDatePicTotalBookingRef.current && !alertDatePicTotalBookingRef.current.contains(event.target)) {
                setShowMonthPicker(false);
                }
             };
              const handleMonthPickerChange = (date) => {
                console.log('handleDateChange.......',date)
                if(date!==undefined){
                    setSelectedMonth(date);
                    setShowMonthPicker(false);
                }
                
                console.log('fetchOptions called from handleDateChange',date)
                
              };
  useEffect(() => {
    getAvailableDocks();
    getCount();
  
    getLocationFreeDocks();
    getTimingList();
    getMonitorList();
     setSelectedMonth(new Date());
  }, []);

  const getAvailableDocks = async () => {
    try {
      const response = await getAvailableDocksApi();
      if (response.data.success === true) {
        setAvailableDockList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCount = async () => {
    try {
      const response = await getCountApi();
      if (response.data.success === true) {
        setDockCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getLocationFreeDocks = async () => {
    try {
      const response = await getLocationFreeDocksApi();
      if (response.data.success === true) {
        setFreeDocks(response.data.data);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTimingList = async () => {
    try {
      const response = await getTimingListApi();
      if (response.data.success === true) {
        setTimingList(response.data.timings);
      }
      return response.data;
        } catch (err) {
          console.error("Error fetching category:", err);
        } finally {
        }
      }; 

      
        const getMonitorList = async () => {   
          try {
            const response = await getLiveMonitorApi();
            if (response.data.success === true) {
              setLiveMonitorList(response.data.docks)
            }
        return response.data;
          } catch (err) {
            console.error("Error fetching category:", err);
          } finally {
          }
        };  
        const locationBasedDockOutDockIn = async () => {   
          try {
            const response = await locationBasedDockOutDockInApi(formatDateCommon(selectedMonth!=null?selectedMonth:'',"MM-YYYY"));
            if (response.data.success === true) {
              setLocationDIDOCount(response.data.count)
              setLocationBasedInAndOut(response.data.data)
            }
        return response.data;
          } catch (err) {
            console.error("Error fetching category:", err);
          } finally {
          }
        };  
             function formatDateCommon(inputDate,formatType) {
                try{
                  if(inputDate!==undefined && inputDate!==null  && inputDate!==""){
                // Parse the input date (MM/DD/YYYY format)
               /*  const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
              
                // Format the date
                return format(parsedDate, formatType); */
                return moment(inputDate).format(formatType)
              }else{
                return "";
              }
              } catch (err) {
                console.error("Error fetching options:", err);
               
              } finally {
                
              }
              }
  return (
    <>
      <div className="d_series">
        <button type="button" className="d_sers_btn" onClick={() => handleScroll("left")}>
          <img src={left} alt="left" srcset="" />
        </button>
        <span className="scroller" ref={scrollRef}>
          {availableDockList.map((item, index) => (
            <div className={`${item.available_status === true ? "available_box" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_box" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_box" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_box" : ""}`} key={"avail_dock" + index}>
              <div>
                <div className={`${item.available_status === true ? "available_text_1" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_text_1" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_text_1" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_text_1" : ""}`}>{item.display_name}</div>
                <div className={`${item.available_status === true ? "available_text_2" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_text_2" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_text_2" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_text_2" : ""}`}>
                  {item.available_status ? "Available" : ""}
                  {item.available_status === false && (
                    <div style={{ width: "50px" }}>
                      <Timer key={"overdelay_timer" + index} initialSeconds={parseDuration(item.duration)} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </span>

        <button type="button" className="d_sers_btn" onClick={() => handleScroll("right")}>
          <img src={right} alt="right" srcset="" />
        </button>
      </div>
      {/* box contain */}
      <Row className="box_contain row d-flex ">
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={gatein} alt="" />
              </div>
              {/*  <div className={`box_percen ${dockCount?.gate_in?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.gate_in?.diff_value==="low"?'-':'+'}{dockCount?.gate_in?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>Gate In</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.gate_in ?? "0"}
                </span>
                {/*  <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={queue} alt="" />
              </div>
              {/*  <div className={`box_percen ${dockCount?.in_queue?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.in_queue?.diff_value==="low"?'-':'+'}{dockCount?.in_queue?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>In Queue</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.in_queue ?? "0"}
                </span>
                {/*  <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={dockin} alt="" />
              </div>
              {/* <div className={`box_percen ${dockCount?.dock_in?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.dock_in?.diff_value==="low"?'-':'+'}{dockCount?.dock_in?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>Dock In</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.dock_in ?? "0"}
                </span>
                {/* <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={dockout} alt="" />
              </div>
              {/*   <div className={`box_percen ${dockCount?.dock_out?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.dock_out?.diff_value==="low"?'-':'+'}{dockCount?.dock_out?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>Dock Out</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.dock_out ?? "0"}
                </span>
                {/* <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={queue} alt="" />
              </div>
              {/*  <div className={`box_percen ${dockCount?.out_queue?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.out_queue?.diff_value==="low"?'-':'+'}{dockCount?.out_queue?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>Out Queue</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.out_queue ?? "0"}
                </span>
                {/* <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12} md={3} lg={4} xl={2} className="mt-2 px-1">
          <div className="boxses col">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="box_icon">
                {" "}
                <img src={gateout} alt="" />
              </div>
              {/*   <div className={`box_percen ${dockCount?.gate_out?.diff_value==="low"?'box_percen_low':''}`}>{dockCount?.gate_out?.diff_value==="low"?'-':'+'}{dockCount?.gate_out?.diff_percent??'0'}%</div> */}
            </div>
            <div className="box_text">
              <p>Gate Out</p>
              <div className="d-flex gap-3">
                <span
                  style={{
                    color: "#172B4D",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}>
                  {dockCount?.gate_out ?? "0"}
                </span>
                {/*  <label htmlFor=""> vehicle vs last month</label> */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* chart contain */}
      <Row className="row d-flex ">
        <Col sm={12} md={6} className='mt-3 '>
        <div className="chart_left col">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <h3>Location based dock in & dock out</h3>
            {/* <select className="month_select" id="exampleSelect">
              <option value="1">June 2025</option>
            </select> */}
             <div onClick={()=>{
              setShowMonthPicker(true);
              }} style={{ position: 'relative',width: '146px',height: '36px',  borderRadius: '10px', display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF' }}>
             <div style={{ fontSize:"13px", fontWeight:"500", color: '#842234' }}>{formatDateCommon(selectedMonth!=null?selectedMonth:undefined,"MMM, YYYY")} &nbsp; <img src={downArrow}/>
             </div>   
             {showMonthPicker && (
        <div  ref={alertDatePicTotalBookingRef} style={{ position: 'absolute', top: '40px',right:'0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
        
         <Calendar
        onChange={handleMonthPickerChange}
        value={selectedMonth}
        view="year"
        onClickMonth={(date) => handleMonthPickerChange(date)}
      />
        </div>
      )}
            </div>
          </div>
          <div
            className="d-flex gap-3"
            style={{ width: "240px", height: "32px" }}
          >
            <span
              style={{ color: locationDIDOCount?.is_low?"#3D9D85":"#fbb", fontSize: "30px", fontWeight: "700" }}
            >
              {locationDIDOCount?.percent??'0'}%
            </span>
            <label
              htmlFor=""
              style={{
                color: " #66737E",
                fontFamily: "Epilogue",
                fontWeight: "400",
                fontSize: "13px",
              }}
            >
              {" "}
             {locationDIDOCount?.is_low?'increased':'decreased'}  from last month
            </label>
          </div>
          <div>
            <div style={{ width: '100%', overflowX: 'auto' }}>
            {/* <ResponsiveContainer width="100%" height={250}> */}
              <BarChart
                data={locationBasedInAndOut??[]}
                barSize={12}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                width={700} // Larger than container to enable scrolling
                 height={220}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                 /*  stroke="#EAEAEA" */
                  vertical={false}
                />
                <XAxis dataKey="location" tickFormatter={(value) => value.length > 10 ? value.substring(0, 10) + '…' : value}/>
                {/* <YAxis /> */}
                <Tooltip content={<CustomTooltip />} cursor={{fill: 'transparent'}}/>
                {/* <Legend /> */}
                <Bar dataKey="in_count" fill="#f66" radius={[10, 10, 0, 0]} activeBar={false}/>
                <Bar
                  dataKey="out_count"
                  fill="#fbb"
                  radius={[10, 10, 0, 0]}
                  activeBar={false}
                />
              </BarChart>
           {/*  </ResponsiveContainer> */}
            </div>
          </div>
        </div>
        </Col>
        <Col sm={12} md={6} className="mt-3 ">
          <div className="chart_right col">
            <div className="d-flex justify-content-between align-items-center" style={{ height: "36px" }}>
              <h3>Location based free docks </h3>
            </div>
            <div className="d-flex row">
              <div className="col-5">
                <div className="flex items-center justify-center " style={{ width: "100%", height: "148px" }}>
                  <svg width="100%" height="100%" viewBox="0 0 200 120">
                    <g transform="translate(100,100)">{segments}</g>

                    {/* Centered Percentage Text */}
                    <text x="100" y="80" textAnchor="middle" fontSize="28" fontWeight="500" fill="#172B4D">
                      {freeDocks?.dock_percentage ?? "0"}%
                    </text>

                    {/* Subtext */}
                    <text x="100" y="100" textAnchor="middle" fontSize="12" fill="#626F86" fontFamily="Epilogue" fontWeight={400}>
                      of docks are free now
                    </text>
                  </svg>
                </div>

                <div className="d-flex flex-column " style={{ backgroundColor: "#F9F9F9", padding: "15px", borderRadius: "10px" }}>
                  <div className="d-flex gap-1">
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        borderRadius: "50px",
                        backgroundColor: "#D35258",
                        marginTop: "3px",
                      }}></div>
                    <div className="live_text">Free docks</div>
                  </div>
                  <div
                    style={{
                      color: "#172B4D",
                      fontSize: "30px",
                      fontWeight: "700",
                    }}>
                    {freeDocks?.count ?? "0"}
                  </div>
                  {/*  <div
                  style={{
                    color: "#66737E",
                    fontSize: "12px",
                    fontFamily: "Epilogue",
                    fontWeight: "400",
                  }}
                >
                  {" "}
                  <span className={`box_percen ${freeDocks?.diff_value==="low"?'box_percen_low':''}`}>{freeDocks?.diff_value==="low"?'-':'+'}{freeDocks?.dock_percentage??'0'}%</span> more than last
                  month
                </div> */}
                </div>
              </div>

              {/* second bar chart  */}
              <div
                className="col"
                style={{
                  // width: "100vw",
                  height: 270,
                  margin: 0,
                  padding: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart layout="vertical" data={freeDocks?.docks} margin={{ top: 20, right: 0, left: 0, bottom: 5 }}>
                    <XAxis type="number" hide />
                    <YAxis
                      type="category"
                      dataKey="city"
                      axisLine={{ stroke: "pink", strokeWidth: 3 }}
                      tick={false}
                      width={0} // removes left spacing
                    />
                    <Tooltip content={<Custom2Tooltip />} cursor={{ fill: "transparent" }} />
                    <Bar dataKey="count" fill="#ffe6e6" radius={[0, 15, 15, 0]} barSize={36}>
                      <LabelList dataKey="count" content={<CircleLabel />} />
                      {freeDocks?.docks.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill="#ffe6e6" />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* time Contain */}
      <div
        className="d-flex row  align-items-center gap-4 p-3 mt-3 mx-1"
        style={{
          width: "100%",

          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
        }}>
        <div
          className=""
          style={{
            color: "#172B4D",
            fontSize: "16px",
            fontWeight: "700",
            fontFamily: "Epilogue",
          }}>
          {" "}
          Timings :
        </div>
        {timingList.map((timing, index) => {
          return (
            <div className="timing_con ">
              <label htmlFor=""> {timing.name ?? ""}</label>
              <div className="duration">
                <img src={time} alt="time" style={{ objectFit: "contain" }} />{" "}
                <span className="ps-2 " style={{ fontWeight: "600", paddingTop: "3px" }}>
                  {timing.loadintime ?? ""}
                </span>{" "}
              </div>
            </div>
          );
        })}

        {/*  <div className="timing_con col-2 d-flex flex-column gap-1">
          <label htmlFor=""> Truck duration</label>
          <label
            htmlFor=""
            style={{ color: "#D35258", fontWeight: "500", marginBottom: "0" }}
            className="mb-0"
          >
            {" "}
            <img src={time} alt="time" />{" "}
            <span style={{ fontWeight: "600" }}>01.00</span> hrs
          </label>
        </div>
        <div className="timing_con col-2 d-flex flex-column gap-1">
          <label htmlFor=""> Lorry duration</label>
          <label htmlFor="" style={{ color: "#D35258", fontWeight: "500" }}>
            {" "}
            <img src={time} alt="time" />{" "}
            <span style={{ fontWeight: "600" }}>00.35</span> hrs
          </label>
        </div> */}
      </div>

      {/* Live moniter */}
      <div className="live_head">Live moniter</div>
      <Row className="live_contain row d-flex">
        <Col sm={12} md={6} lg={4} className="mt-3 ">
          <div className="live_boxses col">
            <div className="d-flex gap-1">
              <div
                style={{
                  height: "12px",
                  width: "12px",
                  borderRadius: "50px",
                  backgroundColor: "#5FD991",
                  marginTop: "3px",
                }}></div>
              <div className="live_text">Loading </div>
            </div>
            <div style={{ height: "425px", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none" }}>
              {liveMonitorList
                ?.filter((item) => item.current_status === "ontime")
                .map((detail, index) => (
                  <div key={"ontime" + index} style={{ position: "relative", backgroundColor: "#DBFFEA" }} className="live_box mt-3">
                    <div>
                      <div className="d-flex align-items-center justify-content-between" style={{ height: "28px" }}>
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "700",
                            color: "#172B4D",
                          }}>
                          {detail.vehicle_number}
                        </div>
                        <div className="box_btn">Loading</div>
                      </div>
                      <div className="d-flex align-items-center">
                        <label className="box_label1">Est. Time : </label>
                        <label className="box_label2 ps-2">{detail.estimated_time}</label>
                      </div>
                      <div className="d-flex mt-2 gap-2">
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock in Time</label>
                          <label className="box_label2">{detail.dock_in_time}</label>
                        </div>
                        <div
                          style={{
                            width: "3px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock Number</label>
                          <label className="box_label2">{detail.display_name}</label>
                        </div>
                        <div
                          style={{
                            width: "2px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Timer</label>
                          <label className="box_label2">
                            <Timer key={"ontime_timer" + index} initialSeconds={parseDuration(detail.duration)} />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="live_box_border" style={{ position: "absolute", left: "12px", bottom: "0" }}></div>
                  </div>
                ))}
            </div>
          </div>
        </Col>
        <Col sm={12} md={6} lg={4} className="mt-3 ">
          <div className="live_boxses col">
            <div className="d-flex gap-1">
              <div
                style={{
                  height: "12px",
                  width: "12px",
                  borderRadius: "50px",
                  backgroundColor: "#FFC267",
                  marginTop: "3px",
                }}></div>
              <div className="live_text">Delay</div>
            </div>
            <div style={{ height: "425px", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none" }}>
              {liveMonitorList
                ?.filter((item) => item.current_status === "delay")
                .map((detail, index) => (
                  <div key={"delay" + index} style={{ position: "relative", backgroundColor: "#FFF1DD" }} className="live_box mt-3">
                    <div>
                      <div className="d-flex align-items-center justify-content-between" style={{ height: "28px" }}>
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "700",
                            color: "#172B4D",
                          }}>
                          {detail.vehicle_number}
                        </div>
                        <div className="box_btn" style={{ color: "#FFC267" }}>
                          Delay
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <label className="box_label1">Est. Time : </label>
                        <label className="box_label2 ps-2">{detail.estimated_time}</label>
                      </div>
                      <div className="d-flex mt-2 gap-2">
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock in Time</label>
                          <label className="box_label2">{detail.dock_in_time}</label>
                        </div>
                        <div
                          style={{
                            width: "3px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock number</label>
                          <label className="box_label2">{detail.display_name}</label>
                        </div>
                        <div
                          style={{
                            width: "2px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Timer</label>
                          <label className="box_label2" style={{ color: "#FFC267" }}>
                            <Timer key={"delay_timer" + index} initialSeconds={parseDuration(detail.duration)} />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="live_box_border" style={{ position: "absolute", left: "12px", bottom: "0", backgroundColor: " #FFC267" }}></div>
                  </div>
                ))}
            </div>
          </div>
        </Col>
        <Col sm={12} md={6} lg={4} className="mt-3 ">
          <div className="live_boxses col">
            <div className="d-flex gap-1">
              <div
                style={{
                  height: "12px",
                  width: "12px",
                  borderRadius: "50px",
                  backgroundColor: "#FE8B90",
                  marginTop: "3px",
                }}></div>
              <div className="live_text">Over-Delay</div>
            </div>
            <div style={{ height: "425px", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none" }}>
              {liveMonitorList
                ?.filter((item) => item.current_status === "overdelay")
                .map((detail, index) => (
                  <div key={"overdelay" + index} className="live_box mt-3" style={{ position: "relative", backgroundColor: "#FFEAEB" }}>
                    <div>
                      <div className="d-flex align-items-center justify-content-between" style={{ height: "28px" }}>
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "700",
                            color: "#172B4D",
                          }}>
                          {detail.vehicle_number}
                        </div>
                        <div className="box_btn" style={{ color: "#FE8B90" }}>
                          Over Delay
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <label className="box_label1">Est. Time : </label>
                        <label className="box_label2 ps-2">{detail.estimated_time}</label>
                      </div>
                      <div className="d-flex mt-2 gap-2">
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock in Time</label>
                          <label className="box_label2">{detail.dock_in_time}</label>
                        </div>
                        <div
                          style={{
                            width: "3px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Dock number</label>
                          <label className="box_label2">{detail.display_name}</label>
                        </div>
                        <div
                          style={{
                            width: "2px",
                            height: "38px",
                            backgroundColor: "#E5E5E5",
                            marginLeft: "10px",
                          }}></div>
                        <div className="d-flex flex-column">
                          <label className="box_label1">Timer</label>
                          <label className="box_label2" style={{ color: "#FE8B90" }}>
                            <Timer key={"overdelay_timer" + index} initialSeconds={parseDuration(detail.duration)} />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="live_box_border" style={{ position: "absolute", left: "12px", bottom: "0", backgroundColor: " #FE8B90" }}></div>
                  </div>
                ))}
            </div>
          </div>
        </Col>
      </Row>
      <div style={{textAlign: "center", marginTop: "80px",fontWeight:"400",fontSize:'12px',color:'#172B4D'}}>
                Powered by <span><img src={mawalog}/></span>
              </div>
    </>
  );
};

export default Default;

const Timer = ({ displayName, initialSeconds }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    /* if (secondsLeft <= 0) return; */

    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, [secondsLeft]);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      <span>{formatDuration(secondsLeft)}</span>
    </div>
  );
};

const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
